module.exports = __webpack_public_path__ + "img/roadmap-phase-1-cell-1-icon.b281e073.png";